<section class="mt-lg-2">
    <!--Grid row-->
    <div class="row">
        <!--Grid column-->
        <div class="col-12 mb-r">
            <!--Card Red-->
            <h2 class="fw-bold">Folios disponibles</h2>
            <div class="card">
                <div class="card-body">
                    <div class="p-2">
                        <table class="table table-hover table-sm align-middle">
                            <thead class="grey lighten-2">
                              <tr>
                                <th scope="col">Tipo Documento</th>
                                <th scope="col">Ultimo Ocupado</th>
                                <th scope="col">Disponibles</th>
                                <th scope="col">Vence</th>
                              </tr>
                            </thead>
                            <ng-container *ngIf="loading">
                              <td colspan="4">
                                <div class="d-flex justify-content-center">
                                  <div class="spinner-border" role="status">
                                  </div>
                                </div>
                              </td>
                            </ng-container>
                            <ng-container *ngIf="!loading">
                              <tbody *ngFor="let dte of groupedDataCaf">
                                <tr *ngFor="let item of dte.items; let i = index">
                                  <ng-container *ngIf="i === 0">
                                    <th scope="row" [attr.rowspan]="dte.items.length" class="align-middle">{{dte.nombre_dte}}</th>
                                  </ng-container>
                                  <ng-container *ngIf="item.folios_disponibles === 0 && item.folios_final === 0 && item.folios_inicial === 0 && item.ultimo_folio === 0">
                                    <td colspan="3">No existen folios</td>
                                  </ng-container>
                                  <ng-container *ngIf="item.folios_disponibles > 0 || item.folios_final > 0 || item.folios_inicial > 0 || item.ultimo_folio > 0">
                                    <td *ngIf="item.ultimo_folio > 0">{{ item.ultimo_folio | numerico}}</td>
                                    <td *ngIf="item.ultimo_folio == 0"></td>
                                    <td>{{item.folios_disponibles | numerico}}</td>
                                    <td>{{item.fecha_vencimiento | date}}</td>
                                  </ng-container>
                                </tr>
                              </tbody>
                              <!-- <tbody *ngFor="let key of groupedDataCaf | keyvalue">
                                <tr *ngFor="let dataCAF of key.value; let i = index">
                                  <ng-container *ngIf="i === 0">
                                    <th scope="row" [attr.rowspan]="key.value.length" class="align-middle">{{dataCAF.nombre_dte}}</th>
                                  </ng-container>
                                  <ng-container *ngIf="dataCAF.folios_disponibles === 0 && dataCAF.folios_final === 0 && dataCAF.folios_inicial === 0 && dataCAF.ultimo_folio === 0">
                                    <td colspan="3">No existen folios</td>
                                  </ng-container>
                                  <ng-container *ngIf="dataCAF.folios_disponibles > 0 || dataCAF.folios_final > 0 || dataCAF.folios_inicial > 0 || dataCAF.ultimo_folio > 0">
                                    <td *ngIf="dataCAF.ultimo_folio > 0">{{ dataCAF.ultimo_folio | numerico}}</td>
                                    <td *ngIf="dataCAF.ultimo_folio == 0"></td>
                                    <td>{{dataCAF.folios_disponibles | numerico}}</td>
                                    <td>{{dataCAF.fecha_vencimiento | date}}</td>
                                  </ng-container>
                                </tr>
                              </tbody> -->
                            </ng-container>
                        </table>
                    </div>
                </div>
            </div>
            <!--/.Card Red-->
        </div>
        <!--Grid column-->
    </div>
    <!--Grid row-->
</section>